<template>
  <div class="container py-3 px-3 py-md-5 px-md-5">
    <page-header header="Student Profile" subText="View the profile of student"></page-header>
    <div class="d-flex py-3 py-md-0 mt-2 mb-4 mb-md-5 tabButtons" :style="cssProps">
      <router-link :to="{name: 'StudentPersonalInfo'}">Personal Info</router-link>
      <router-link :to="{name: 'StudentEducationHistory'}">Educational History</router-link>
      <router-link :to="{name: 'StudentExamScoresHistory'}">Exam Scores</router-link>
      <router-link :to="{name: 'StudentBackgroundInfoHistory'}">Background Info</router-link>
      <router-link :to="{name: 'StudentDocumentList'}">Documents</router-link>
    </div>
    <router-view ref="childComp"/>
  </div>
</template>
<script>
import PageHeader from '@/components/PageHeader.vue'
import { Colors } from '@/utils/constants'

export default {
  name: 'ViewStudentProfile',
  components: {
    PageHeader
  },
  data: function () {
    return {
      authenticated: true,
      currentTab: 0
    }
  },
  methods: {
    switchTabs (val) {
      this.currentTab = val
    }
  },
  computed: {
    cssProps () {
      return {
        '--primary-color': Colors.primaryColor,
        'overflow-x': 'auto'
      }
    },
    currentUser () {
      return this.$store.state.admin.currentUser
    }
  },
  mounted () {
    if (this.currentUser == null) {
      this.$router.push('/admin/login')
    }
  }
}
</script>
<style scoped>
  .tabButtons a{
    text-decoration: none;
    margin-right: 50px;
    font-weight: 500;
    color: gray;
  }

  .tabButtons a.router-link-exact-active{
    color: var(--primary-color);
  }
</style>
